import { useEffect } from 'react';
import { Form } from 'antd';

import { selectEligibleProductIdentityAction } from 'containers/Snaps/Snap/store';

const { useWatch, useFormInstance } = Form;

export const ProductMatchesFieldsChange = () => {
  const form = useFormInstance();

  const matchedProductValue = useWatch('matchedProduct', form);
  const matchedProductTouched = form.isFieldTouched('matchedProduct');

  useEffect(() => {
    if (matchedProductTouched) {
      form.resetFields(['matchedBy']);
    }

    if (typeof matchedProductValue === 'object') {
      selectEligibleProductIdentityAction(matchedProductValue.id);
    }
  }, [matchedProductValue, matchedProductTouched]);

  return null;
};
